import { Heading, Modal } from '@zillow/constellation-10';

import { useRentalManagerUserClaimWebApiHandler_propertyLookupAll } from '@zg-rentals/ts-rental-manager-api-client-react-query';

import { isEmailInContactMethods, isPhoneInContactMethods } from '../../../utils/listingClaimUtils';

import ClaimListingCard from '../../ClaimListingCard';
import ModalFooter from '../ModalFooter';

type ViewClaimListingsModalProps = {
  isOpen?: boolean;
  includeUnverified?: boolean;
  onClose: () => void;
};

const ViewClaimListingsModal = ({ isOpen = true, onClose, includeUnverified = true }: ViewClaimListingsModalProps) => {
  const {
    data,
    isFetching: isLoading,
    isError: hasError,
  } = useRentalManagerUserClaimWebApiHandler_propertyLookupAll(
    { includeVerified: true, includeUnverified },
    { enabled: !!isOpen },
  );

  const listings = data?.listings ?? [];
  const contactMethods = data
    ? { emails: data.contactMethods?.emails ?? [], phones: data.contactMethods?.phones ?? [] }
    : undefined;

  const renderContent = () => {
    return (
      <div>
        {listings.map((listing) => (
          <ClaimListingCard
            key={`listing-card-${listing?.listingAlias}`}
            listingData={listing}
            highlightPhone={contactMethods ? isPhoneInContactMethods(contactMethods, listing?.contactPhone) : false}
            highlightEmail={contactMethods ? isEmailInContactMethods(contactMethods, listing?.contactEmail) : false}
            loading={isLoading}
          />
        ))}
      </div>
    );
  };

  return (
    <Modal
      open={isOpen}
      onOpenChange={(open) => !open && onClose()}
      size={{ base: 'fullScreen', md: 'md' }}
      header={<Heading level={2}>View listings</Heading>}
      body={renderContent()}
      footer={<ModalFooter hasError={hasError} onSubmit={onClose} submitText="Done" />}
    />
  );
};

export default ViewClaimListingsModal;
